import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    liveResultListLoading: false,
    liveResultListSuccess: null,
    liveResultListError: '',

    getAppearedStudentsListLoading: false,
    getAppearedStudentsListSuccess: null,
    getAppearedStudentsListError: '',

    getResultAnalysisLoading: false,
    getResultAnalysisSuccess: null,
    getResultAnalysisError: '',
    challengeListLoading: false,
    challengeListSuccess: null,
    challengeListError: '',
    challengeCountListLoading: false,
    challengeCountListSuccess: null,
    challengeCountListError: '',

}


export const liveResultSlice = createSlice({
    name: 'liveResult',
    initialState, 
    reducers: {
        setLiveResultListLoading: (state) => {
            state.liveResultListLoading = true;
            state.liveResultListSuccess = null;
            state.liveResultListError = '';
        },
        setLiveResultListSuccess: (state, action) => {
            state.liveResultListLoading = false;
            state.liveResultListSuccess = action.payload;
            state.liveResultListError = '';
        },
        setLiveResultListError: (state, action) => {
            state.liveResultListLoading = false;
            state.liveResultListSuccess = null;
            state.liveResultListError = action.payload;
        },
        setGetAppearedStudentsListLoading: (state) => {
            state.getAppearedStudentsListLoading= true;
            state.getAppearedStudentsListSuccess= null;
            state.getAppearedStudentsListError= '';
        },
        setGetAppearedStudentsListSuccess: (state, action) => {
            state.getAppearedStudentsListLoading= false;
            state.getAppearedStudentsListSuccess= action.payload;
            state.getAppearedStudentsListError= '';
        },
        setGetAppearedStudentsListError: (state, action) => {
            state.getAppearedStudentsListLoading= false;
            state.getAppearedStudentsListSuccess= null;
            state.getAppearedStudentsListError= action.payload;
        },

        setGetResultAnalysisLoading: (state) => {
            state.getResultAnalysisLoading= true;
            state.getResultAnalysisSuccess= null;
            state.getResultAnalysisError= '';
        },
        setGetResultAnalysisSuccess: (state, action) => {
            state.getResultAnalysisLoading= false;
            state.getResultAnalysisSuccess= action.payload;
            state.getResultAnalysisError= '';
        },
        setGetResultAnalysisError: (state, action) => {
            state.getResultAnalysisLoading= false;
            state.getResultAnalysisSuccess= null;
            state.getResultAnalysisError= action.payload;
        },
        setChallengeListLoading: (state) => {
            state.challengeListLoading = true;
            state.challengeListSuccess = null;
            state.challengeListError = '';
        },
        setChallengeListSuccess: (state, action) => {
            state.challengeListLoading = false;
            state.challengeListSuccess = action.payload;
            state.challengeListError = '';
        },
        setChallengeListError: (state, action) => {
            state.challengeListLoading = false;
            state.challengeListSuccess = null;
            state.challengeListError = action.payload;
        },
        setChallengeCountListLoading: (state) => {
            state.challengeCountListLoading = true;
            state.challengeCountListSuccess = null;
            state.challengeCountListError = '';
        },
        setChallengeCountListSuccess: (state, action) => {
            state.challengeCountListLoading = false;
            state.challengeCountListSuccess = action.payload;
            state.challengeCountListError = '';
        },
        setChallengeCountListError: (state, action) => {
            state.challengeCountListLoading = false;
            state.challengeCountListSuccess = null;
            state.challengeCountListError = action.payload;
        },
    }
})

export const { setLiveResultListLoading, setLiveResultListSuccess, setLiveResultListError, 
    setGetAppearedStudentsListLoading, setGetAppearedStudentsListSuccess, setGetAppearedStudentsListError, 
    setGetResultAnalysisLoading, setGetResultAnalysisSuccess, setGetResultAnalysisError ,setChallengeListLoading, setChallengeListSuccess, setChallengeListError, setChallengeCountListLoading, setChallengeCountListSuccess, setChallengeCountListError,} = liveResultSlice.actions;


export default liveResultSlice.reducer;